__webpack_require__.p = "/glb_scene/babylon_bathroom/";